import { Button, TextField, Typography } from "@hellocarbo/lasagne";
import { ChangeEvent, Dispatch, SetStateAction, useState } from "react";
import { useTranslation } from "react-i18next";

import useSignupSteps from "@/hooks/useSignupSteps";

import Template from "./Template";

const EmailStep = ({
  email,
  setEmail,
}: {
  email: string;
  setEmail: Dispatch<SetStateAction<string>>;
}) => {
  const { t } = useTranslation(["common", "signUp"]);
  const { goToNextStep } = useSignupSteps();

  const [hasError, setHasError] = useState(false);

  const handleContinue = () => {
    // naive client side email format validation
    const regex =
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

    if (regex.test(email)) {
      goToNextStep();
    } else {
      setHasError(true);
    }
  };

  return (
    <Template
      title={t("signUp:email.title")}
      subtitle={t("signUp:email.subtitle")}
      buttonText={t("continue")}
      onClick={handleContinue}
      secondaryAction={
        <div className="gap-3xs flex items-center justify-center">
          <Typography step="-1" className="text-grayscale">
            {t("signUp:alreadyHaveAnAccount")}
          </Typography>
          <Button shape="link" size="small" as="a" href="/users/sign_in">
            {t("signUp:signIn")}
          </Button>
        </div>
      }
    >
      <TextField
        label={t("signUp:email.label")}
        value={email}
        onChange={(e: ChangeEvent<HTMLInputElement>) => {
          setEmail(e.target.value);
        }}
        fullWidth
        type="email"
        name="email"
        error={hasError ? t("signUp:email.error") : undefined}
        onFocus={() => setHasError(false)}
      />
    </Template>
  );
};

export default EmailStep;
